import React,{Component} from 'react'
import firebase from '../../helper/firebase'

import {
  Card,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import SecurityIcon from 'material-ui-icons/Security'
import NotificationsIcon from 'material-ui-icons/Notifications'

import Head from '../../components/Head'
import LoggedOutCard from '../../components/LoggedOutCard'
import ApplicantCardHeader from '../../components/ApplicantCardHeader'
import SectionTitle from '../../components/SectionTitle'
import SkeletonCard from '../../components/SkeletonCard'
import {Title} from '../../helper/consts'

const style = {
  loading:{
    alignSelf: 'center',
    width:'75px',
    height:'75px',
    marginTop:'calc(50vh - 37.5px - 64px)',
  },
}

export default class Settings extends Component{
  componentDidMount(){
    this.props.actions.setSettingsListener()
  }

  componentWillUnmount(){
    this.props.loggedIn && firebase.database().ref(`settings/${this.props.uid}`).off();
  }

  handleToggle=(item)=>{
    const {settings,uid} = this.props;
    const ref = firebase.database().ref();
    let newStatus = !settings[item];
    ref.child(`settings/${uid}/`).update({[`${item}`]:newStatus})
    .then(()=>{
      this.props.actions.setSnack(true,`Settings Updated: ${item} is ${newStatus}`)
    })
    .catch(err=>{
      console.log(err);
      this.props.actions.setSnack(true,`Error: ${item} is still ${newStatus}`)
    })
  }

  handleNotificationToggle=()=>{
    const {settings,uid} = this.props;
    if(settings.notifications===true){
      this.handleToggle('notifications')
    }
    else{
      const messaging = firebase.messaging();
      messaging.requestPermission()
      .then(()=>{
        this.GetFCMToken(uid);
      })
      .catch((err)=>{
        this.props.actions.setSnack(true,`Error: ${err}.`)
      });
    }
  }

  GetFCMToken=(uid)=>{
    const messaging = firebase.messaging();
    messaging.getToken()
    .then((currentToken)=>{
      if (currentToken) {
        console.log(currentToken);
        firebase.database().ref(`settings/${uid}/`).update({
          notifications:true,
          token:currentToken,
        })
      } else {
        // Show permission request.
        console.log('No Instance ID token available. Request permission to generate one.');
        // Show permission UI.
      }
    })
    .catch((err)=>{
      this.props.actions.setSnack(true,`Error: ${err.message}.`)
    });
  }

  renderPrivacySettings=()=>{
    const {user,settings} = this.props;
    let html = [];
    let title = (<SectionTitle key='privacy_title' title='Privacy' />)
    html.push(title)
    let form = (
      <Fade key='Privacy' in={true}>
        <Card className='card'>
          <ApplicantCardHeader applicant={user} />
          <List>
            <Divider light />
            <ListItem button disableRipple onClick={()=>{this.handleToggle('public')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Public Profile" secondary='Turning this on will set your profile page publicly visible.'/>
              <ListItemSecondaryAction>
                <Switch
                  onChange={()=>{this.handleToggle('public');}}
                  checked={settings['public']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider light />
            <ListItem disabled={settings[`public`]!==true} button disableRipple onClick={()=>{this.handleToggle('public_email')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Email Address" secondary='Turning this on will set your email address visible on your profile page.'/>
              <ListItemSecondaryAction>
                <Switch
                  disabled={settings[`public`]!==true}
                  onChange={()=>{this.handleToggle('public_email');}}
                  checked={settings['public_email']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider light />
            <ListItem disabled={settings[`public`]!==true} button disableRipple onClick={()=>{this.handleToggle('public_industry')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Industry" secondary='Turning this on will set your industry title visible on your profile page.'/>
              <ListItemSecondaryAction>
                <Switch
                  disabled={settings[`public`]!==true}
                  onChange={()=>{this.handleToggle('public_industry');}}
                  checked={settings['public_industry']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider light />
            <ListItem disabled={settings[`public`]!==true} button disableRipple onClick={()=>{this.handleToggle('public_function')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Function" secondary='Turning this on will set your job function (role) visible on your profile page.'/>
              <ListItemSecondaryAction>
                <Switch
                  disabled={settings[`public`]!==true}
                  onChange={()=>{this.handleToggle('public_function');}}
                  checked={settings['public_function']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider light />
            <ListItem disabled={settings[`public`]!==true} button disableRipple onClick={()=>{this.handleToggle('public_avatar')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Avatar" secondary='Turning this on will set your avatar visible on your profile page.'/>
              <ListItemSecondaryAction>
                <Switch
                  disabled={settings[`public`]!==true}
                  onChange={()=>{this.handleToggle('public_avatar');}}
                  checked={settings['public_avatar']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider light />
            <ListItem disabled={settings[`public`]!==true} button disableRipple onClick={()=>{this.handleToggle('public_skills')}}>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Skills" secondary='Turning this on will set your skills to visible on your profile page.'/>
              <ListItemSecondaryAction>
                <Switch
                  disabled={settings[`public`]!==true}
                  onChange={()=>{this.handleToggle('public_skills');}}
                  checked={settings['public_skills']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Card>
      </Fade>
    )
    html.push(form);
    return html;
  }

  renderNotificationsSettings=()=>{
    const {settings} = this.props;
    let html = [];
    let title = (<SectionTitle key='notifications_title' title='Notifications' />)
    html.push(title);
    let form = (
      <Fade key='notifications' in={true}>
        <Card className='card'>
          <List>
            <ListItem button disableRipple onClick={()=>{this.handleNotificationToggle()}}>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="App Notifications" secondary='App notifications appear in your browser and work with the latest browsers.'/>
              <ListItemSecondaryAction>
                <Switch
                  onChange={()=>{this.handleNotificationToggle()}}
                  checked={settings['notifications']===true}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Card>
      </Fade>
    )
    html.push(form);
    return html;
  }

  render(){
    return(
      <React.Fragment>
        <Head title={`Settings | ${Title}`} />
        <div id={this.props.loggedIn?'loggedInBody':null} className="body">
          {this.props.authLoading && <CircularProgress style={style.loading} size={75} />}

          {this.props.loggedIn && this.props.settingsLoading && <SkeletonCard header={true} content={true} actions={true} />}
          {this.props.loggedIn && !this.props.settingsLoading && this.renderPrivacySettings()}

          {this.props.loggedIn && !this.props.settingsLoading && this.renderNotificationsSettings()}

          {!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Settings/Settings.js